import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
    selector: 'app-sitemap',
    templateUrl: './sitemap.component.html',
    styleUrls: ['./sitemap.component.scss'],
})
export class SitemapComponent implements OnInit {
    constructor(private dialogRef: MatDialogRef<SitemapComponent>) {}
    visible = false;
    activeTab = 'headings';

    tabs = [
        { id: 'headings', label: 'Encabezados' },
        { id: 'sections', label: 'Secciones' },
        { id: 'links', label: 'Enlaces' },
    ];

    headings: { text: string; id: any; tag: string }[] = [];
    sections: { text: string; id: any; tag: string }[] = [];
    links: { href: string; text: string }[] = [];

    ngOnInit() {
        this.openSitemap();
    }

    ngAfterViewInit() {
        setTimeout(() => this.extractContent(), 0);
    }

    openSitemap() {
        this.visible = true;
        this.extractContent();
    }

    closeSitemap() {
        this.dialogRef.close();
    }

    extractContent() {
        // Encabezados
        const hs = Array.from(document.querySelectorAll('h1, h2, h3'));
        this.headings = hs
            .filter((el: Element) => {
                return !el.closest('app-accessibility, app-sitemap');
            })
            .map((el: Element, index: number) => {
                const htmlEl = el as HTMLElement;
                const id = htmlEl.id || `heading-${index}`;
                if (!htmlEl.id) htmlEl.id = id;
                return {
                    id,
                    text: htmlEl.textContent?.trim() || '(Sin texto)',
                    tag: htmlEl.tagName.toLowerCase(),
                };
            });

        // Secciones
        const secs = Array.from(document.querySelectorAll('section'));
        this.sections = secs
            .filter((el: Element) => {
                const text = el.textContent?.trim();

                // Excluir secciones texto visible
                if (!text) return false;
                return true;
            })
            .map((el: Element, index: number) => {
                const htmlEl = el as HTMLElement;
                const id = htmlEl.id || `section-${index}`;
                if (!htmlEl.id) htmlEl.id = id;

                return {
                    id,
                    text: htmlEl.getAttribute('aria-label') || htmlEl.querySelector('h1, h2, h3')?.textContent?.trim() || htmlEl.querySelector('a, p')?.textContent?.trim() || '(Sin texto)',
                    tag: htmlEl.tagName.toLowerCase(),
                };
            });

        //console.log(this.sections);

        // Enlaces
        const as = Array.from(document.querySelectorAll('a[href]'));
        this.links = Array.from(
            new Map(
                as
                    .filter((el: Element) => {
                        const href = (el as HTMLAnchorElement).href;
                        const text = el.textContent?.trim();

                        // Excluir enlaces vacíos o sin texto
                        if (!text) return false;

                        // Excluir los generados por Leaflet
                        if (href.includes('tile.openstreetmap.org') || href.includes('leaflet') ||  href.includes('close') || href.startsWith('blob:') || href.startsWith('javascript:') || el.closest('.leaflet-control')) {
                            return false;
                        }

                        return true;
                    })
                    .map((el: Element) => [
                        (el as HTMLAnchorElement).href,
                        {
                            href: (el as HTMLAnchorElement).href,
                            text: el.textContent!.trim(),
                        },
                    ])
            ).values()
        );

        //console.log(Array.from(document.querySelectorAll('a[href]')));
    }

    irAHeading(id: string) {
        const elemento = document.getElementById(id);
        if (elemento) {
            this.dialogRef.close(id);
        }
    }
}
